import React from 'react';
import glamorous from 'glamorous';

import withPrismJs from '../with-prismjs-hoc';

import SubFieldFilename from './subfield-filename';
import SubFieldMediaType from './subfield-media-type';
import SubFieldAltText from './subfield-alt-text';
import { MENU_ENTRIES } from '../constants';

const ComplexFieldImages = () => {
  return (
    <div data-subsection={MENU_ENTRIES.complexFieldImages}>
      <h3>
        COMPLEX FIELD: IMAGES
      </h3>
      <div>
        <p>
          There may be one or several images linked to one recall.
          All images <strong>MUST</strong> be in the same folder as the XML file describing the recall.
          The file name(s) of the image(s) <strong>MUST BE EXACTLY</strong> the same as those referenced in the XML file
          describing the recall, otherwise an error will be thrown by the interface or the API.
        </p>
      </div>
      <br/><br/>
      <div data-subsection={MENU_ENTRIES.complexFieldImagesFilename}>
        <SubFieldFilename/>
      </div>
      <br/><br/>
      <div data-subsection={MENU_ENTRIES.complexFieldImagesMediaType}>
        <SubFieldMediaType/>
      </div>
      <br/><br/>
      <div data-subsection={MENU_ENTRIES.complexFieldImagesAltText}>
        <SubFieldAltText/>
      </div>
    </div>
  );
};

export default withPrismJs(ComplexFieldImages);



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/complex-field-images/index.js